import i18n from 'i18next';

import { LanguageCode, LanguageItems } from '@type';
import { isIos, isIOSBrowser } from '@utils';

import { ANDROID_PLAY_STORE_LINK, IOS_APP_STORE_LINK } from './config';

export const generateTermsAndConditionsLink = () => {
  const currentLanguageCode = i18n.language;

  if (
    currentLanguageCode.startsWith(LanguageItems.English.code) ||
    currentLanguageCode.startsWith(LanguageItems.Arabic.code)
  ) {
    return 'https://www.myoncare.com/terms-and-conditions?tab=patients';
  }
  return `https://www.myoncare.com/${currentLanguageCode}/terms-and-conditions?tab=patients`;
};

export const generatePrivacyPolicyLink = () => {
  const currentLanguage = i18n.language;
  const languageCode = Object.values(LanguageItems).find(item =>
    currentLanguage.startsWith(item.code)
  )?.code;

  switch (languageCode) {
    case LanguageItems.English.code:
      return 'https://www.myoncare.com/privacy-policy?tab=patientsEU';
    case LanguageItems.German.code:
    case LanguageItems.French.code:
      return `https://www.myoncare.com/${languageCode}/privacy-policy?tab=patientsEU`;
    case LanguageItems.Portuguese.code:
    case LanguageItems.Italian.code:
      return `https://www.myoncare.com/${languageCode}/privacy-policy?tab=patients`;
    case LanguageItems.Arabic.code:
      return 'https://www.myoncare.com/privacy-policy?tab=patientsEG';
    default:
      return 'https://www.myoncare.com/privacy-policy?tab=patientsEU';
  }
};

export const generateInstructionsForUseLink = () => {
  const currentLanguage = i18n.language;
  const ifuLanguageMap = {
    en: 'eng',
    de: 'ger',
    ar: 'eng',
    it: 'ita',
    fr: 'fra',
    pt: 'prt',
  };
  const languageCode = Object.values(LanguageItems).find(item =>
    currentLanguage.startsWith(item.code)
  )?.code;
  const targetLanguage = ifuLanguageMap[languageCode as LanguageCode];
  return `https://www.myoncare.com/e-ifu/app-guidelines-for-use-${targetLanguage}`;
};

export const getStoreLink = () =>
  isIos() || isIOSBrowser ? IOS_APP_STORE_LINK : ANDROID_PLAY_STORE_LINK;
